import queryString from "query-string";

import { EGranularities } from "app/pages/app-intelligence/constants";
import type { IUserKeywordGroup } from "app/services/keyword-groups";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { SourceTypeMap } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import { EMonitorKeywordsGraphTabs } from "./types";

export const getExcelLink = (
    country: string,
    tab: keyof typeof EMonitorKeywordsGraphTabs,
    keywordGroup: IUserKeywordGroup,
    selectedActivationSetDomains: string[],
    shareOfVoiceExcelUrl: string,
    volumeOverTimeExcelUrl: string,
) => {
    const lastMonthDuration = DurationService.getDurationData(BasicDurations.LAST_MONTH).forAPI;
    const lastThirteenMonthsDuration = DurationService.getDurationData(BasicDurations.LAST_THIRTEEN_MONTHS).forAPI;

    const excelDownloadUrl = tab === EMonitorKeywordsGraphTabs[0] ? shareOfVoiceExcelUrl : volumeOverTimeExcelUrl;
    const excelParams =
        tab === EMonitorKeywordsGraphTabs[0] && selectedActivationSetDomains
            ? {
                  country,
                  To: lastMonthDuration.to,
                  From: lastMonthDuration.from,
                  Device: devicesTypes.TOTAL,
                  isWindow: false,
                  sourceType: SourceTypeMap.Total,
                  keys: keywordGroup.Id,
                  keyword: `*${keywordGroup.Id}`,
                  timeGranularity: EGranularities.MONTHLY,
                  Duration: BasicDurations.LAST_THIRTEEN_MONTHS,
                  SitesFilterExact: selectedActivationSetDomains?.join(","),
              }
            : {
                  GroupHash: keywordGroup.GroupHash,
                  UseVolume2: true,
                  country,
                  from: lastThirteenMonthsDuration.from,
                  includeSubDomains: true,
                  isWindow: false,
                  keys: keywordGroup.Id,
                  to: lastThirteenMonthsDuration.to,
                  webSource: devicesTypes.TOTAL,
              };

    return `${excelDownloadUrl}?${queryString.stringify(excelParams)}`;
};
